import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import useEmblaCarousel from "embla-carousel-react";
import * as Accordion from "@radix-ui/react-accordion";

import { text } from "../../text";
import { URLS } from "../../config";
import { hooks } from "../../hooks";
import { utils } from "../../utils";
import { svg } from "../../assets/svg";
import { theme } from "../../constants";
import { components } from "../../components";
import { course as elements } from "../../course";
import { review as reviews } from "../../reviews";

import categoriesdata from "../../staticdata/categories";
import properties from "../../staticdata/properties";
import { reviewsData } from "../../staticdata/reviewData";
import banner from "../../assets/nestfin/BANNER IMAGE.jpg";
import banner2 from "../../assets/nestfin/BANNER_IMAGE2.png";
import { BlockHeading } from "../../components/BlockHeading";
import { CourseCard } from "../../course/CourseCard";
import carouselImage from "../../assets/nestfin/3d1.png";
import logo from "../../assets/nestfin/Nestfin_logo.png";
import WhatsappIcon from "../../assets/nestfin/whatsapp.png";
// import logo from "../../assets/nestfin/NexfinPng.png"
import { callService } from "../../customHook/callService";
import {
  accessToken,
  fetchBudgetFriendly,
  fetchNearMe,
  fetchPremiumProperty,
  fetchPropertyByFilters,
  formatIndianNumber,
  leadIdFromStorage,
  recentSearchProperties,
} from "../../environment";
import useApi from "../../customHook/useApi";

// ------- images -------
// import ROOMS_image from "../../assets/nestfin/rooms-property.jpeg";
// import RK1_image from "../../assets/nestfin/1rk-property.jpg";
// import RK2_image from "../../assets/nestfin/2rk-property.jpg";
// import BHK1_image from "../../assets/nestfin/1bhk-property-2.webp";
// import BHK2_image from "../../assets/nestfin/2bhk-property.avif";
// import BHK3_image from "../../assets/nestfin/3bhk-property.jpg";
import ROOMS_image from "../../assets/Nestfin_rooms/Rooms.png";
import RK1_image from "../../assets/Nestfin_rooms/1_RK.png";
import RK2_image from "../../assets/Nestfin_rooms/2_RK.png";
import BHK1_image from "../../assets/Nestfin_rooms/1_BHK.png";
import BHK2_image from "../../assets/Nestfin_rooms/2_BHK.png";
import BHK3_image from "../../assets/Nestfin_rooms/3_BHK.png";

import Men_image from "../../assets/nestfin/men-image-1.png";
import Women_image from "../../assets/nestfin/women-image-1.png";
import Couple_image from "../../assets/nestfin/couple-image-1.png";
// ----- end images -----

// ----- videos -----
import reviewVd1 from "../../assets/Nestfin_videos/1.mp4";
import reviewVd2 from "../../assets/Nestfin_videos/2.mp4";
import reviewVd3 from "../../assets/Nestfin_videos/3.mp4";
import reviewVd4 from "../../assets/Nestfin_videos/4.mp4";
// --- end videos ---

import { CustomLoader, CustomLoaderSmall } from "../../components/CustomLoader";
import NoDataFound from "../../components/nodataFound/NoDataFound";
import fallBackImg from "../../assets/nestfin/No_image_Found.png";
import { Nestfin_Number } from "../../constants/constantData";
import { useDrawer } from "../../customHook/useDrawerContext";
import { HelpAndSupport } from "../HelpAndSupport";
import { all_routes } from "../../routes/all_routes";
import { Helmet } from "react-helmet-async";

export interface Feature {
  feature_id: number;
  feature_name: string;
  icon: string;
}

export interface PropertyType {
  property_id: string;
  property_name: string;
  address: string;
  locality_id: string;
  locality_name: string | null;
  city_id: string;
  city_name: string;
  pincode: string;
  state: string;
  features: Feature[] | null;
  photos: any; // can refine this later
  minimum_rent: number;
}

export interface FilterResponse {
  success: boolean;
  statusCode: number;
  data: PropertyType[];
  category_summary?: any[];
}

const buttonTagStyle = {
  backgroundColor: "var(--primary-color)",
  padding: "5px 7px",
  borderRadius: "8px",
  color: "white",
  cursor: "pointer",
  fontSize: "10px",
  letterSpacing: "1px",
};

export const Home: React.FC = () => {
  const navigate = hooks.useNavigate();
  const location = useLocation();
  const { pathname } = useLocation();
  const { isDrawerOpen } = useDrawer();

  const [loading, setLoading] = useState(true);
  const [emblaRef, emblaApi] = useEmblaCarousel();
  const [activeIndex, setActiveIndex] = useState(0);
  const [coursesData, setCoursesData] = useState([]);
  const [bannersData, setBannersData] = useState([]);
  const [categoriesData, setCategoriesData] = useState<any>([]);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [startIndex, setStartIndex] = useState(0);

  const [viewport, setViewport] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const [localityReady, setLocalityReady] = useState(false);

  const selectedCity = localStorage.getItem("selectedCity");

  // console.log(isDrawerOpen, "isdraweropen");

  // =======>>> api <<<========
  // CAll Api for Recent Serach
  const {
    data: recentSearchData,
    loading: recentSearchLoading,
    callApi: fetchRecent,
  } = useApi<FilterResponse>(recentSearchProperties, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });

  useEffect(() => {
    setLoading(true);
    const leadId = localStorage.getItem("lead_profile_id") || "";
    // console.log(leadId, " lead id for recent seawrch");

    const payload = {
      leadId: leadId,
    };
    fetchRecent(payload) // Make sure you're calling the correct API hook
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    // console.log(recentSearchData?.data, "recentSearchData.......");
  }, [recentSearchData]);

  // CAll Api
  const {
    data: propertyData,
    loading: propertyLoading,
    callApi: fetchProperty,
  } = useApi<FilterResponse>(fetchPropertyByFilters, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });
  const {
    data: premiumPropertyData,
    loading: premiumPropertyLoading,
    callApi: fetchPremiumPropertyAPI,
  } = useApi<FilterResponse>(fetchPremiumProperty, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });

  // api call deafult value
  useEffect(() => {
    const fetchProperties = async () => {
      setLoading(true);

      // ✅ Get saved location from sessionStorage
      const storedLatLng = localStorage.getItem("selectedLatLng");
      let localityData: { lat: number; lon: number }[] = [];

      if (storedLatLng) {
        try {
          localityData = JSON.parse(storedLatLng) as {
            lat: number;
            lon: number;
          }[];
        } catch (err) {
          console.error(
            "Error parsing selectedLatLng from sessionStorage:",
            err,
          );
        }
      }

      // console.log("---locality data---", localityData);
      if (localityData.length > 0) {
        // ✅ Call API with saved location
        const payload = {
          leadId: localStorage.getItem("lead_profile_id") || "",
          cityId: localStorage.getItem("selectedCityId") || "1",
          localityId: localityData,
        };

        // console.log("📤 Fetching properties with saved location:", payload);
        console.log("payload home page: ", payload);
        const response = await fetchProperty(payload);
        const response1 = await fetchPremiumPropertyAPI(payload);

        // ✅ If no data returned, fallback to default city
        if (!response?.data?.length) {
          // console.log("📤 No properties found, falling back to default city");
          const defaultPayload = {
            leadId: localStorage.getItem("lead_profile_id") || "",
            cityId: localStorage.getItem("selectedCityId") || "1",
            localityId: [],
          };
          await fetchProperty(defaultPayload);
          await fetchPremiumPropertyAPI(defaultPayload);
        }
      } else {
        const defaultPayload = {
          leadId: localStorage.getItem("lead_profile_id") || "",
          cityId: localStorage.getItem("selectedCityId") || "1",
          localityId: [],
        };
        // console.log("📤 Fetching default city properties:", defaultPayload);
        await fetchProperty(defaultPayload);
        await fetchPremiumPropertyAPI(defaultPayload);
      }

      setLoading(false);
    };

    fetchProperties();
  }, []);

  // CAll Api fetchBudgetFriendly
  const {
    data: fetchBudgetFriendlyData,
    loading: fetchBudgetFriendlyLoading,
    callApi: fetchBudgetFriendlyFun,
  } = useApi<FilterResponse>(fetchBudgetFriendly, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });

  // CAll Api fetchBudgetFriendly
  const {
    data: fetchPropertyNearMe,
    loading: fetchPropertyNearMeLoading,
    callApi: fetchPropertyNearMeFun,
  } = useApi<FilterResponse>(fetchNearMe, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });

  useEffect(() => {
    const cityId = localStorage.getItem("selectedCityId") || "1";

    const storedLatLng = localStorage.getItem("selectedLatLng");
    const selectedLatLng = storedLatLng ? JSON.parse(storedLatLng) : [];
    const lat = selectedLatLng?.[0]?.lat?.toString() ?? null;
    const lon = selectedLatLng?.[0]?.lon?.toString() ?? null;

    const payload = {
      city: cityId,
      latitude: lat,
      longitude: lon,
    };

    fetchBudgetFriendlyFun(payload);
    fetchPropertyNearMeFun(payload);
  }, []);

  // useEffect(() => {
  //   console.log(fetchPropertyNearMe?.data, "fetchNearMeData");
  //   // console.log(fetchBudgetFriendlyData?.data, "fetchBudgetFriendlyData");
  // }, [fetchBudgetFriendlyData, fetchPropertyNearMe]);

  useEffect(() => {
    const storedLatLng = localStorage.getItem("selectedLatLng");
    if (storedLatLng) {
      setLocalityReady(true);
    }
  }, []);

  // ✅ Function to call API
  const callApiWithPayload = async (payload: any) => {
    setLoading(true);
    // console.log(payload, "payload before response ");

    const response = await fetchProperty(payload);
    // console.log(response, "response from server");

    // console.log(payload, "payload after response ");

    if (response?.data?.length === 0 && payload.localityId?.length > 0) {
      // console.log("📤 No data found, calling API without lat/lon");

      const newPayload = { ...payload, localityId: [], cityId: "1" };
      await fetchProperty(newPayload);
    }
    setLoading(false);
  };

  useEffect(() => {
    // ✅ Call API immediately
    if (!localityReady) return;

    setLoading(true);
    const leadId = localStorage.getItem("lead_profile_id") || "";
    const cityId = localStorage.getItem("selectedCityId") || "1";

    // ✅ Get user's saved location from sessionStorage
    const storedLatLng = localStorage.getItem("selectedLatLng");
    let localityData: { lat: number; lon: number }[] = [];

    if (storedLatLng) {
      try {
        localityData = JSON.parse(storedLatLng) as {
          lat: number;
          lon: number;
        }[];
      } catch (err) {
        console.error("Error parsing selectedLatLng from sessionStorage:", err);
      }
    }

    // ✅ Build payload dynamically
    const payload = {
      leadId: leadId,
      cityId: cityId,
      localityId: localityData.length > 0 ? localityData : [], // use saved lat/lon or empty array
    };

    // console.log("📤 Calling API with payload:", payload);
    callApiWithPayload(payload);

    setLoading(false);
  }, [localityReady]);

  useEffect(() => {
    const handleResize = () => {
      setViewport({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
    };
    scrollToTop();
  }, [pathname]);

  const handleSlideChange = () => {
    if (emblaApi) {
      setActiveIndex(emblaApi.selectedScrollSnap());
    }
  };

  useEffect(() => {
    if (emblaApi) {
      emblaApi.on("select", handleSlideChange);
    }
  }, [emblaApi]);

  useEffect(() => {
    const leadHomePage = async () => {
      try {
        const response = await callService("HOMEPAGE");
        // console.log("✅ HOMEPAGE success:", response);
      } catch (error) {
        console.error("❌ HOMEPAGE failed:", error);
      }
    };
    leadHomePage();
  }, []);

  const [showLocationPopup, setShowLocationPopup] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const popupShown = localStorage.getItem("locationPopupShown");
    const leadIdFromStorage = localStorage.getItem("lead_profile_id") ?? "";
    const accessToken = localStorage.getItem("accessToken");
    const shouldShowPopup = !popupShown && (!leadIdFromStorage || !accessToken);

    if (shouldShowPopup) {
      const timer = setTimeout(() => {
        setShowLocationPopup(true);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    localStorage.removeItem("category");
    localStorage.setItem("genderAPI", "");
    localStorage.setItem("gender", "");
  }, []);

  // ✅ Handle user’s response to location popup
  const handleAllowLocation = async (action: "Allow" | "Don't Allow") => {
    setShowLocationPopup(false);

    // ✅ Mark popup as shown so it doesn’t appear again
    localStorage.setItem("locationPopupShown", "true");

    if (action === "Allow") {
      console.log("allow");
      if (navigator.geolocation) {
        console.log(
          "--home allowlocation func inside ---",
          navigator.geolocation.getCurrentPosition,
        );

        navigator.geolocation.getCurrentPosition(
          async (position) => {
            console.log("dfjl");
            const lat = position.coords.latitude;
            const lon = position.coords.longitude;

            console.log(
              "--home allowlocation func inside ---",
              navigator.geolocation,
            );
            console.log("position", position);

            // Save coordinates in sessionStorage
            const previousLatLng = JSON.parse(
              localStorage.getItem("selectedLatLng") || "[]",
            ) as { lat: number; lon: number }[];

            const updatedLatLng = [...previousLatLng, { lat, lon }];
            localStorage.setItem(
              "selectedLatLng",
              JSON.stringify(updatedLatLng),
            );

            // 🔹 Fetch locality dynamically from coordinates
            try {
              const res = await fetch(
                `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`,
              );
              const data = await res.json();
              const addr = data.address || {};

              // 🔹 Try to construct a more complete, user-friendly name
              const localityName =
                [
                  addr.suburb ||
                    addr.neighbourhood ||
                    addr.village ||
                    addr.hamlet ||
                    addr.road,
                  addr.city || addr.town || addr.county || addr.state_district,
                ]
                  .filter(Boolean)
                  .join(", ") || "Unknown Location";

              // ✅ Determine city name (prefer exact city or fallback)
              const cityName =
                addr.city?.toLowerCase() ||
                addr.town?.toLowerCase() ||
                addr.county?.toLowerCase() ||
                addr.state_district?.toLowerCase() ||
                "";

              // ✅ set city to ID
              let cityId = "1";
              if (cityName.includes("noida")) {
                cityId = "2";
              } else if (
                cityName.includes("gurugram") ||
                cityName.includes("gurgaon")
              ) {
                cityId = "3";
              } else if (cityName.includes("delhi")) {
                cityId = "1";
              }

              // console.log(cityName, " cityNamecoming for without login");

              localStorage.setItem(
                "selectedLocality",
                JSON.stringify([localityName]),
              );

              localStorage.setItem(
                "selectedCity",
                cityName
                  ? cityName.charAt(0).toUpperCase() + cityName.slice(1)
                  : "Delhi",
              );
              localStorage.setItem("selectedCityId", cityId);
              console.log(cityId, " cityId From Allow Button ");
              console.log(lat, " lat From Allow Button ");
              console.log(lon, " lon From Allow Button ");

              const payload = {
                city: cityId,
                latitude: lat,
                longitude: lon,
              };

              fetchBudgetFriendlyFun(payload);
              fetchPropertyNearMeFun(payload);
            } catch (err) {
              console.error("Failed to fetch locality:", err);
              localStorage.setItem(
                "selectedLocality",
                JSON.stringify(["Unknown Location"]),
              );
            }

            setError("");
            setLocalityReady(true);
          },
          (err) => {
            console.error("Error getting location:", err);
            setError("Failed to fetch location. Please allow access.");
          },
        );
      } else {
        setError("Geolocation is not supported by your browser.");
      }
    } else {
      // ❌ User denied location access
      console.error("❌ User denied location access.");

      try {
        const newPayload = {
          leadId: "", // optional
          cityId: "1", // default city
          localityId: [], // empty array
        };

        await callApiWithPayload(newPayload);

        // Optionally set a default locality if needed
        localStorage.setItem("selectedLocality", JSON.stringify([]));

        setLocalityReady(true);
      } catch (error) {
        console.error("Error fetching default properties:", error);
      }
    }
  };

  // ***************** START COMPONENT ********************************
  const renderBottomTabBar = (): JSX.Element => {
    return <components.BottomTabBar />;
  };

  const renderTopBlock = (): JSX.Element => {
    return (
      <div className="container" style={{ marginBottom: 0 }}>
        <div className="" style={{ marginTop: 20, marginBottom: 10 }}>
          <div style={{ flexDirection: "column" }}>
            <text.H5 numberOfLines={1}>
              Find, Book, Pay, and Live with Ease.
            </text.H5>
          </div>
        </div>
      </div>
    );
  };

  const renderIndicator = (): JSX.Element => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          bottom: 20,
          left: 20,
          flexDirection: "row",
          gap: 8,
        }}
      >
        {bannersData?.map((item: any, index: number) => {
          const isSelected = index === activeIndex;
          return (
            <div
              style={{
                background: isSelected
                  ? "#7065F0"
                  : theme.colors.secondaryTextColor,
                width: 10,
                // width: isSelected ? 25 : 10,
                height: 10,
                borderRadius: 5,
              }}
              key={index}
            />
          );
        })}
      </div>
    );
  };

  const renderSearchBar = (): JSX.Element => {
    return (
      <div className="container">
        <div
          style={{
            padding: "9px 16px",
            width: "100%",
            marginBottom: 20,
            left: 20,
            top: 24,
            borderRadius: 5,
            border: "1px solid #ddd",
            backgroundColor: "#fff",
            ...utils.rowCenter(),
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
          onClick={() => navigate("/onbording7")}
        >
          <svg.SearchSvg />
          <text.T14 style={{ fontWeight: "bold", color: "#00000078" }}>
            Search Location
          </text.T14>
          <div style={{ cursor: "pointer" }}>
            <svg.FilterSvg color="var(--secondary-color)" />
          </div>
        </div>
      </div>
    );
  };

  const renderCarouselContent = (): JSX.Element => {
    return (
      <div className="embla" ref={emblaRef}>
        <div className="embla__container">
          {propertyData?.data
            ?.slice(1, 4)
            ?.map((course: any, index: number) => {
              // console.log("carousel", course);

              return (
                <div
                  key={course.property_id}
                  className="embla__slide carousel-slide"
                  onClick={() => {
                    // console.log("----- couser clicked ----", course);
                    navigate("/course-details", {
                      state: { course: course },
                      // state: { course: coursesData[index] },
                    });
                  }}
                >
                  <div
                    className="carousel-image-wrapper"
                    style={{
                      backgroundImage: `url(${
                        course.photos?.[0]?.photo_path || carouselImage
                      })`,
                    }}
                    // style={{ backgroundImage: `url(${carouselImage})` }}
                  >
                    <div className="bannerCardContent">
                      {/* <p className="bannerCardTag">Semi Furnished</p> */}
                      <p className="bannerCardPrice">
                        {/* Rs. {course.minimum_rent} / month */}₹
                        {formatIndianNumber(course?.minimum_rent)} / month
                      </p>
                      <p className="bannerCardType">{course.property_name}</p>
                      <p className="bannerCardLocation">
                        {course.city_name}, {course.pincode}
                      </p>
                    </div>
                    <elements.CourseRating
                      course={course}
                      containerStyle={{
                        margin: 2,
                        position: "absolute",
                        right: 18,
                        bottom: 10,
                      }}
                    />

                    {/* <elements.CourseInWishlist
                    course={course}
                    size={20}
                    style={{ position: 'absolute', right: 20, top: 23 }}
                  /> */}
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    );
  };

  const renderCarousel = () => {
    // console.log("-------?>>>> ", propertyData?.data);

    if (!propertyData?.data?.length) return null;
    return (
      <div style={{ position: "relative", marginBottom: 10, marginTop: 15 }}>
        <components.BlockHeading
          title="Perfect Match "
          //  viewAllVisible={false}
          viewAllOnClick={() => {
            navigate("/category-list", {
              state: {
                title: "Perfect Match",
                propertyList: propertyData?.data,
              },
            });
          }}
          containerStyle={{ marginBottom: 12, padding: "0 20px" }}
        />
        {renderCarouselContent()}
        {renderIndicator()}
      </div>
    );
  };

  // Perfect Match for You
  const renderTopRatedCourses = (): JSX.Element | null => {
    const defaultImage =
      "https://drahomes.in/images/properties-chennai-dra-astra-flats-madhavaram-chennai.jpg";

    if (!propertyData?.data?.length) return null;
    return (
      <div style={{ marginBottom: 0, marginTop: 40 }}>
        <div style={{ backgroundColor: "#f0fff0", padding: "20px 0" }}>
          <components.BlockHeading
            title="Smart Suggestions"
            viewAllOnClick={() => {
              navigate("/category-list", {
                state: {
                  title: "Smart Suggestions",
                  propertyList: propertyData?.data,
                },
              });
            }}
            containerStyle={{ marginBottom: 12, padding: "0 20px" }}
          />

          {propertyData?.data?.slice(1, 2)?.map((course: any, index, array) => {
            const isLast = index === array.length - 1;
            // console.log(course);
            return (
              <div
                key={course.property_id}
                style={{
                  width: "100%",
                  padding: "0 20px",
                  cursor: "pointer",
                  userSelect: "none",
                  display: "flex",
                  alignItems: "center",
                  marginBottom: isLast ? 0 : 10,
                  paddingBottom: isLast ? 0 : 10,
                  borderBottomWidth: isLast ? 0 : 1,
                  borderBottomStyle: isLast ? "none" : "solid",
                  borderBottomColor: `rgba(59, 89, 153, 0.1)`,
                }}
                onClick={() =>
                  navigate("/course-details", { state: { course } })
                }
              >
                <div
                  style={{
                    minWidth: 140,
                    minHeight: 110,
                    marginRight: 12,
                    position: "relative",
                  }}
                >
                  <img
                    src={course?.photos?.[0]?.photo_path || defaultImage}
                    style={{
                      width: "100%",
                      height: "100%",
                      borderRadius: 10,
                      position: "absolute",
                      inset: 0,
                    }}
                  />

                  {/* <elements.CourseRating
                    course={course}
                    containerStyle={{
                      margin: 2,
                      position: 'absolute',
                      bottom: 0,
                      left: 0,
                    }}
                  /> */}
                </div>
                <div style={{ width: "100%", position: "relative" }}>
                  <div style={{ display: "flex", marginLeft: 10 }}>
                    <div>
                      <p
                        className="typeOfRoom"
                        style={{ fontSize: "17px", marginTop: "6px" }}
                      >
                        {course?.property_name}
                      </p>
                      <text.T16
                        style={{
                          color: "var(--secondary-color)",
                          ...theme.fonts.Lato_700Bold,
                        }}
                      >
                        {/* ₹{course?.minimum_rent} / Month */}₹
                        {formatIndianNumber(course?.minimum_rent)} / month
                      </text.T16>
                      <elements.CourseName
                        course={course}
                        numberOfLines={1}
                        shortName={true}
                      />
                      <text.T16 style={{ color: "#000" }}>
                        {course?.city_name} {course?.pincode}
                      </text.T16>
                    </div>
                  </div>
                  {/* <elements.CourseInWishlist
                    course={course}
                    size={20}
                    style={{ position: 'absolute', right: 0, top: 0 }}
                  /> */}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const renderReview = (): JSX.Element | null => {
    if (!reviewsData?.length) return null;
    return (
      <div style={{ marginBottom: 0, marginTop: 40 }}>
        <components.BlockHeading
          title="What people are saying"
          // viewAllOnClick={() => {
          //   // navigate('/category-list', { state: { title: 'Nearest For You' } });
          // }}
          containerStyle={{ marginBottom: 12, padding: "0 20px" }}
        />
        <Swiper
          spaceBetween={16}
          slidesPerView="auto"
          // centeredSlides={true}
          pagination={{ clickable: true }}
        >
          {reviewsData?.slice(0, 3)?.map((review: any, index, array) => {
            const isLast = index === array.length - 1;
            return (
              <SwiperSlide
                key={review.id}
                style={{
                  width: 350,
                  cursor: "pointer",
                  userSelect: "none",
                  borderRadius: 10,
                  display: "flex",
                  flexDirection: "column",
                  position: "relative",
                  backgroundColor: "#F9FAFC",
                  padding: "20px 20px 0px 20px",
                }}
                onClick={() => {
                  // navigate('/course-details', { state: { review } });
                }}
              >
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    height: 320,
                    marginBottom: 10,
                  }}
                >
                  <img
                    src={review?.image}
                    alt={review?.name}
                    style={{
                      width: "100%",
                      height: "100%",
                      position: "absolute",
                      borderRadius: 3,
                      inset: 0,
                    }}
                  />
                </div>
                <div style={{}}>
                  <reviews.ReviewCard review={review} section="reviews" />
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    );
  };

  const renderCounter = (): JSX.Element => {
    return (
      <div style={{ marginBottom: 20, marginTop: 20 }}>
        <div
          style={{
            ...utils.rowCenter(),
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            textAlign: "center",
            gap: "10px",
          }}
        >
          <h3
            style={{
              color: theme.colors.darkTextColor,
              ...theme.fonts.Lato_700Bold,
              ...theme.flex,
              fontSize: 32,
            }}
          >
            Trusted by
          </h3>

          <h3
            style={{
              color: theme.colors.darkTextColor,
              ...theme.fonts.Lato_700Bold,
              ...theme.flex,
              fontSize: 28,
            }}
          >
            Customers in Delhi NCR
          </h3>
          <h3
            style={{
              // lineHeight: 1,
              color: theme.colors.darkTextColor,
              ...theme.fonts.Lato_700Bold,
              ...theme.flex,
              fontSize: 28,
            }}
          >
            {" "}
            and growing every day
          </h3>
        </div>
      </div>
    );
  };

  const renderBottomCard = (): JSX.Element => {
    const handleShare = () => {
      if (navigator.share) {
        navigator
          .share({
            title: "Check out Nestfin!",
            text: "I found this awesome app — try it out!",
            url: all_routes.tenantsNestfinApp ?? "",
          })
          .then(() => console.log("Thanks for sharing!"))
          .catch((error) => console.error("Error sharing:", error));
      } else {
        // Fallback if Web Share API is not supported
        alert(
          `Sharing not supported on this browser. Copy this link: ${all_routes.tenantsNestfinApp}`,
        );
      }
    };

    return (
      <div className="bottom-card-container">
        <div className="bottom-card-content">
          {/* Left Content */}
          <div className="bottom-card-left">
            {/* <h3 className="bottom-card-heading">Like the app?</h3>
            <h3 className="bottom-card-subheading">
              Share the app with your friends!
            </h3> */}
            <h3 className="bottom-card-heading">
              Help your friends find PG & Co-Living near them —
            </h3>
            <h3 className="bottom-card-subheading">Share the NestFin App</h3>
            <button className="bottom-card-button" onClick={handleShare}>
              Share Now
            </button>
          </div>

          {/* Right Image */}
          <div className="bottom-card-image-wrapper">
            <img
              src={require("../../assets/nestfin/bottomcardimg.png")}
              alt="Share the app illustration"
            />
          </div>
        </div>
      </div>
    );
  };

  const renderPopular = (): JSX.Element => {
    return (
      <div style={{ marginBottom: 0, marginTop: 30 }}>
        <components.BlockHeading
          title="Recently Added Properties "
          viewAllOnClick={() => {
            navigate("/category-list", {
              state: { title: "Recently Added Properties" },
            });
          }}
          containerStyle={{ marginBottom: 12, padding: "0 20px" }}
        />
        <Swiper
          spaceBetween={16}
          slidesPerView={"auto"}
          pagination={{ clickable: true }}
        >
          {properties?.properties.map((course: any, index, array) => {
            const isLast = index === array.length - 1;
            return (
              <SwiperSlide
                key={course.id}
                style={{
                  width: 230,
                  cursor: "pointer",
                  userSelect: "none",
                  borderRadius: 10,
                  display: "flex",
                  flexDirection: "column",
                  position: "relative",
                }}
                onClick={() => {
                  navigate("/course-details", { state: { course } });
                }}
              >
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    height: 170,
                    marginBottom: 10,
                  }}
                >
                  <img
                    src={course?.preview_90x90}
                    alt={course?.name}
                    style={{
                      width: "100%",
                      height: "100%",
                      position: "absolute",
                      borderRadius: 10,
                      inset: 0,
                    }}
                  />
                  <elements.CourseRating
                    course={course}
                    containerStyle={{
                      position: "absolute",
                      left: 2,
                      bottom: 2,
                    }}
                  />
                  {/* <elements.CourseInWishlist
                    course={course}
                    size={20}
                    style={{
                      position: 'absolute',
                      right: 0,
                      top: 0,
                      margin: 10,
                    }}
                    customFillColor={theme.colors.white}
                    customStrokeColor={theme.colors.white}
                  /> */}
                </div>
                <div style={{ display: "flex" }}>
                  {/* <div style={{ marginRight: 8 }}>
                    <svg.PlaySvg />
                  </div> */}
                  <div>
                    <elements.CourseName
                      course={course}
                      numberOfLines={1}
                      shortName={true}
                    />

                    <text.T16
                      style={{ color: theme.colors.secondaryTextColor }}
                    >
                      London University
                    </text.T16>
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    );
  };
  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        goBack={false}
        line={false}
        leftlogo={true}
        rightlogo={false}
        // search={true}
        filter={false}
        // logo={true}
        title={" "}
        centerImageSrc={logo}
      />
    );
  };

  const renderBanner = (): JSX.Element => {
    return (
      <div className="container">
        <img
          src={banner}
          alt=""
          style={{ borderRadius: "11px", overflow: "hidden" }}
        />
      </div>
    );
  };

  const renderBanner2 = (): JSX.Element => {
    return (
      <div className="container" style={{ marginTop: "55px" }}>
        <img
          // src={banner}
          src={banner2}
          alt=""
          style={{ borderRadius: "11px", overflow: "hidden" }}
        />
      </div>
    );
  };

  const renderNearest = (): JSX.Element | null => {
    const defaultImage = fallBackImg;

    if (!recentSearchData?.data?.length) return null;

    return (
      <div style={{ marginBottom: 0, marginTop: 35 }}>
        <BlockHeading
          title="Recent Search"
          // viewAllVisible={false}
          // viewAllVisible={propertyData?.data?.length > 5}
          viewAllOnClick={() => {
            navigate("/category-list", {
              state: {
                title: "Recent Search",
                propertyList: recentSearchData?.data,
              },
            });
          }}
          containerStyle={{ marginBottom: 12, padding: "0 20px" }}
        />
        <Swiper
          spaceBetween={16}
          slidesPerView={"auto"}
          pagination={{ clickable: true }}
        >
          {recentSearchData?.data?.length === 0 ? (
            <NoDataFound message="No recent searches found" />
          ) : (
            recentSearchData?.data
              ?.slice(0, 6)
              .map((course: any, index: number) => (
                <SwiperSlide
                  key={course?.property_id || index}
                  style={{
                    width: 230,
                    cursor: "pointer",
                    userSelect: "none",
                    borderRadius: 10,
                    display: "flex",
                    flexDirection: "column",
                    position: "relative",
                  }}
                  onClick={() => {
                    const localitySlug =
                      course?.locality_name
                        ?.toLowerCase()
                        ?.replace(/\s+/g, "-") || "locality";
                    const citySlug =
                      course?.city_name?.toLowerCase()?.replace(/\s+/g, "-") ||
                      "city";
                    const propertySlug =
                      course?.property_name
                        ?.toLowerCase()
                        ?.replace(/\s+/g, "-") || "property";
                    const propertyId = `?id=${btoa(course?.property_id) || ""}`;

                    const customUrl = `/rooms/${localitySlug}/${citySlug}/${propertySlug}/${propertyId}`;
                    navigate(customUrl, { state: { course } });
                  }}
                >
                  {/* <img src={homeImg} alt="" /> */}
                  <div className="nearestCardWrapper">
                    <div
                      className="nearestCardBackground"
                      style={{
                        backgroundImage: `url(${
                          course?.photos?.[0]?.photo_path || defaultImage
                        })`,
                        // backgroundImage: `url(${homeImg})`,
                      }}
                    />
                    <div
                      className="nearestCardContent"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "0px",
                      }}
                    >
                      {/* Buttons right-aligned above the property name */}

                      {/* Property name */}
                      <p className="nearestCardType">{course.property_name}</p>

                      <p
                        style={{
                          margin: 0,
                          marginTop: "5px",
                          fontSize: "12px",
                        }}
                      >
                        Starts from
                      </p>
                      <p className="nearestCardPrice">
                        {/* ₹{course.minimum_rent} / month */}₹
                        {formatIndianNumber(course?.minimum_rent)} / month
                      </p>
                      <p className="nearestCardLocation">
                        {course?.locality_name
                          ? `${course.locality_name}, `
                          : ""}
                        {course?.city_name}
                      </p>
                    </div>
                  </div>

                  <div
                    style={{
                      position: "absolute",
                      top: "15px",
                      right: "10px",
                      display: "flex",
                      gap: "4px",
                      fontWeight: "bold",
                      zIndex: "100",
                    }}
                  >
                    <button style={buttonTagStyle}>
                      {course?.category?.toUpperCase()}
                    </button>

                    <button style={buttonTagStyle}>
                      {course?.gender_allowed?.toUpperCase()}
                    </button>

                    <button style={buttonTagStyle}>
                      {/* {course?.is_meal_provided ? "Meal" : "No Meal"} */}
                      {(!!course?.is_meal_provided &&
                        course?.is_meal_provided?.toLowerCase()) == "yes"
                        ? "MEAL"
                        : "NO MEAL"}
                    </button>
                  </div>
                </SwiperSlide>
              ))
          )}
        </Swiper>
      </div>
    );
  };

  const renderNearest2 = (): JSX.Element | null => {
    const defaultImage = fallBackImg;

    if (!fetchBudgetFriendlyData?.data?.length) return null;

    return (
      <div style={{ marginBottom: 0, marginTop: 35 }}>
        <BlockHeading
          title="Budget-Friendly"
          viewAllOnClick={() => {
            navigate("/category-list", {
              state: {
                title: "Budget-Friendly",
                propertyList: fetchBudgetFriendlyData?.data,
                // propertyList: propertyData?.data,
              },
            });
          }}
          containerStyle={{ marginBottom: 12, padding: "0 20px" }}
        />

        <Swiper
          spaceBetween={16}
          slidesPerView={"auto"}
          pagination={{ clickable: true }}
        >
          <Swiper
            spaceBetween={16}
            slidesPerView={"auto"}
            pagination={{ clickable: true }}
          >
            {fetchBudgetFriendlyData?.data
              ?.slice(0, 5)
              .map((course: any, index, array) => {
                const isLast = index === array.length - 1;
                return (
                  <SwiperSlide
                    key={course.property_id}
                    style={{
                      width: 230,
                      cursor: "pointer",
                      userSelect: "none",
                      borderRadius: 10,
                      display: "flex",
                      flexDirection: "column",
                      position: "relative",
                    }}
                    onClick={() => {
                      const localitySlug =
                        course?.locality_name
                          ?.toLowerCase()
                          ?.replace(/\s+/g, "-") || "locality";
                      const citySlug =
                        course?.city_name
                          ?.toLowerCase()
                          ?.replace(/\s+/g, "-") || "city";
                      const propertySlug =
                        course?.property_name
                          ?.toLowerCase()
                          ?.replace(/\s+/g, "-") || "property";
                      const propertyId = `?id=${btoa(course?.property_id) || ""}`;

                      const customUrl = `/rooms/${localitySlug}/${citySlug}/${propertySlug}/${propertyId}`;

                      navigate(customUrl, {
                        state: { course, property_id: course.property_id },
                      });
                    }}
                  >
                    <div className="nearestCardWrapper">
                      <div
                        className="nearestCardBackground"
                        style={{
                          backgroundImage: `url(${
                            course?.photos?.[0]?.photo_path || defaultImage
                          })`,
                          // backgroundImage: "/assets/nestfin/homeimg.jpg",
                        }}
                      />

                      <div className="nearestCardContent">
                        <p className="nearestCardType">
                          {course.property_name}
                        </p>
                        <p
                          style={{
                            margin: 0,
                            marginTop: "5px",
                            fontSize: "12px",
                          }}
                        >
                          Starting from
                        </p>

                        <p className="nearestCardPrice">
                          ₹{formatIndianNumber(course?.minimum_rent)} / month
                        </p>

                        {/* <p className="nearestCardLocation">
                          {course?.locality_name
                            ? `${course.locality_name}, `
                            : ""}
                          {course?.city_name} 
                        </p> */}

                        <p className="nearestCardLocation">
                          {course?.locality_name
                            ? `${course.locality_name}, `
                            : ""}
                          {course?.city_name}
                        </p>
                      </div>
                    </div>
                    <div
                      style={{
                        position: "absolute",
                        top: "15px",
                        right: "10px",
                        zIndex: 1000,
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "4px",
                      }}
                    >
                      {course?.category && (
                        <button style={buttonTagStyle}>
                          {course?.category?.toUpperCase()}
                        </button>
                      )}

                      {course?.gender_allowed && (
                        <button style={buttonTagStyle}>
                          {course?.gender_allowed?.toUpperCase()}
                        </button>
                      )}

                      <button style={buttonTagStyle}>
                        {(!!course?.is_meal_provided &&
                          course?.is_meal_provided?.toLowerCase()) == "yes"
                          ? "MEAL"
                          : "NO MEAL"}
                      </button>
                    </div>
                  </SwiperSlide>
                );
              })}
          </Swiper>
        </Swiper>
      </div>
    );
  };

  const renderNearest3 = (): JSX.Element | null => {
    const defaultImage = fallBackImg;

    if (!fetchPropertyNearMe?.data?.length) return null;

    return (
      <div style={{ marginBottom: 0, marginTop: 35 }}>
        <BlockHeading
          title="Property Near Me"
          viewAllOnClick={() => {
            navigate("/category-list", {
              state: {
                title: "Property Near Me",
                propertyList: fetchPropertyNearMe?.data,
              },
            });
          }}
          containerStyle={{ marginBottom: 12, padding: "0 20px" }}
        />

        <Swiper
          spaceBetween={16}
          slidesPerView={"auto"}
          pagination={{ clickable: true }}
        >
          <Swiper
            spaceBetween={16}
            slidesPerView={"auto"}
            pagination={{ clickable: true }}
          >
            {/* {fetchPropertyNearMe?.data */}
            {fetchPropertyNearMe?.data
              ?.slice(0, 5)
              .map((course: any, index, array) => {
                const isLast = index === array.length - 1;
                return (
                  <SwiperSlide
                    key={course.property_id}
                    style={{
                      width: 230,
                      cursor: "pointer",
                      userSelect: "none",
                      borderRadius: 10,
                      display: "flex",
                      flexDirection: "column",
                      position: "relative",
                    }}
                    onClick={() => {
                      const localitySlug =
                        course?.locality_name
                          ?.toLowerCase()
                          ?.replace(/\s+/g, "-") || "locality";
                      const citySlug =
                        course?.city_name
                          ?.toLowerCase()
                          ?.replace(/\s+/g, "-") || "city";
                      const propertySlug =
                        course?.property_name
                          ?.toLowerCase()
                          ?.replace(/\s+/g, "-") || "property";
                      const propertyId = `?id=${btoa(course?.property_id) || ""}`;

                      const customUrl = `/rooms/${localitySlug}/${citySlug}/${propertySlug}/${propertyId}`;

                      navigate(customUrl, {
                        state: { course, property_id: course.property_id },
                      });
                    }}
                  >
                    <div className="nearestCardWrapper">
                      <div
                        className="nearestCardBackground"
                        style={{
                          backgroundImage: `url(${
                            course?.photos?.[0]?.photo_path || defaultImage
                          })`,
                        }}
                      />

                      <div className="nearestCardContent">
                        <p className="nearestCardType">
                          {course.property_name}
                        </p>
                        <p
                          style={{
                            margin: 0,
                            marginTop: "5px",
                            fontSize: "12px",
                          }}
                        >
                          Starting from
                        </p>

                        <p className="nearestCardPrice">
                          {/* ₹{course.minimum_rent} / month */}₹
                          {formatIndianNumber(course?.minimum_rent)} / month
                        </p>
                        {/* <p className="nearestCardLocation">
                          {course?.locality_name}, {course?.city_name}
                        </p> */}
                        <p className="nearestCardLocation">
                          {course?.locality_name
                            ? `${course.locality_name}, `
                            : ""}
                          {course?.city_name}
                        </p>
                      </div>
                    </div>

                    <div
                      style={{
                        position: "absolute",
                        top: "15px",
                        right: "10px",
                        zIndex: 1000,
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "4px",
                        // gap: "8px",
                        marginBottom: "10px",
                      }}
                    >
                      {course?.category && (
                        <button style={buttonTagStyle}>
                          {course?.category?.toUpperCase()}
                        </button>
                      )}

                      {course?.gender_allowed && (
                        <button style={buttonTagStyle}>
                          {course?.gender_allowed?.toUpperCase()}
                        </button>
                      )}

                      <button style={buttonTagStyle}>
                        {(!!course?.is_meal_provided &&
                          course?.is_meal_provided?.toLowerCase()) == "yes"
                          ? "MEAL"
                          : "NO MEAL"}
                      </button>
                    </div>
                  </SwiperSlide>
                );
              })}
          </Swiper>
        </Swiper>
      </div>
    );
  };

  const renderNearest4 = (): JSX.Element | null => {
    const defaultImage = fallBackImg;
    // console.log("premium property", premiumPropertyData);
    if (!premiumPropertyData?.data?.length) return null;

    return (
      <div style={{ marginBottom: 0, marginTop: 35 }}>
        <BlockHeading
          title="Premium Property"
          // viewAllVisible={false}
          viewAllOnClick={() => {
            navigate("/category-list", {
              state: {
                title: "Premium Property",
                propertyList: premiumPropertyData?.data,
              },
            });
          }}
          containerStyle={{ marginBottom: 12, padding: "0 20px" }}
        />

        <Swiper
          spaceBetween={16}
          slidesPerView={"auto"}
          pagination={{ clickable: true }}
        >
          <Swiper
            spaceBetween={16}
            slidesPerView={"auto"}
            pagination={{ clickable: true }}
          >
            {premiumPropertyData?.data
              ?.slice(0, 5)
              .map((course: any, index, array) => {
                const isLast = index === array.length - 1;
                return (
                  <SwiperSlide
                    key={course.property_id}
                    style={{
                      width: 230,
                      cursor: "pointer",
                      userSelect: "none",
                      borderRadius: 10,
                      display: "flex",
                      flexDirection: "column",
                      position: "relative",
                    }}
                    onClick={() => {
                      const localitySlug =
                        course?.locality_name
                          ?.toLowerCase()
                          ?.replace(/\s+/g, "-") || "locality";
                      const citySlug =
                        course?.city_name
                          ?.toLowerCase()
                          ?.replace(/\s+/g, "-") || "city";
                      const propertySlug =
                        course?.property_name
                          ?.toLowerCase()
                          ?.replace(/\s+/g, "-") || "property";
                      const propertyId = `?id=${btoa(course?.property_id) || ""}`;

                      const customUrl = `/rooms/${localitySlug}/${citySlug}/${propertySlug}/${propertyId}`;

                      navigate(customUrl, {
                        state: { course, property_id: course.property_id },
                      });
                    }}
                  >
                    <div className="nearestCardWrapper">
                      <div
                        className="nearestCardBackground"
                        style={{
                          backgroundImage: `url(${
                            course?.photos?.[0]?.photo_path || defaultImage
                          })`,
                        }}
                      />

                      <div className="nearestCardContent">
                        <p className="nearestCardType">
                          {course.property_name}
                        </p>
                        <p
                          style={{
                            margin: 0,
                            marginTop: "5px",
                            fontSize: "12px",
                          }}
                        >
                          Starting from
                        </p>

                        <p className="nearestCardPrice">
                          {/* ₹{course.minimum_rent} / month */}₹
                          {formatIndianNumber(course?.minimum_rent)} / month
                        </p>
                        {/* <p className="nearestCardLocation">
                          {course?.locality_name}, {course?.city_name}
                        </p> */}
                        <p className="nearestCardLocation">
                          {course?.locality_name
                            ? `${course.locality_name}, `
                            : ""}
                          {course?.city_name}
                        </p>
                      </div>
                    </div>

                    <div
                      style={{
                        position: "absolute",
                        top: "15px",
                        right: "10px",
                        zIndex: 1000,
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "4px",
                        marginBottom: "10px",
                      }}
                    >
                      {course?.category && (
                        <button style={buttonTagStyle}>
                          {course?.category?.toUpperCase()}
                        </button>
                      )}

                      {course?.gender_allowed && (
                        <button style={buttonTagStyle}>
                          {course?.gender_allowed?.toUpperCase()}
                        </button>
                      )}

                      <button style={buttonTagStyle}>
                        {(!!course?.is_meal_provided &&
                          course?.is_meal_provided?.toLowerCase()) == "yes"
                          ? "MEAL"
                          : "NO MEAL"}
                      </button>
                    </div>
                  </SwiperSlide>
                );
              })}
          </Swiper>
        </Swiper>
      </div>
    );
  };

  const renderReelReview = (): JSX.Element | null => {
    const videoList = [
      {
        id: 1,
        src: reviewVd1,
        title: `I searched everywhere but couldn’t find a PG. After using Nestfin, I finally found an affordable PG close to my college.`,
        // title: `“I had been searching everywhere for a PG but couldn’t find one. Using NestFin, I finally found an affordable PG near my college.”`,
        name: "Aarav Mehta",
        location: "Delhi, Azadpur",
      },
      {
        id: 2,
        src: reviewVd2,
        title: `I was looking for a clean and safe PG, and on Nestfin I found a perfect one. The photos were real too.`,
        // "“Very clean and secure. Felt just like home. Highly recommend this PG!”",
        name: "Sneha Kapoor",
        location: "Delhi, Nirman Vihar",
      },
      {
        id: 3,
        src: reviewVd3,
        title: `I used Nestfin to find a PG and it helped me get a really good one.`,
        // title:"“Responsive management and peaceful environment. Perfect for working professionals.”",
        name: "Rohit Sharma",
        location: "Noida, Sector 62",
      },
      {
        id: 4,
        src: reviewVd4,
        title: `I used Nestfin and found a comfortable PG. Now I don’t have to run around every day for autos, buses, or the metro.`,
        // "“I used NestFin and found a perfect PG, so now I don’t have to run around for buses or autos.”",
        name: "Priya Nair",
        location: "Noida, Sector 63",
      },
    ];

    if (!videoList?.length) return null;
    return (
      <div style={{ marginTop: 40 }}>
        <components.BlockHeading
          // title="What people are saying"
          title="What Residents Are Saying About NestFin"
          // viewAllOnClick={() => { }}
          containerStyle={{ marginBottom: 12, padding: "0 20px" }}
        />

        <Swiper spaceBetween={16} slidesPerView="auto">
          {videoList?.map((video, index) => (
            <SwiperSlide
              key={video.id}
              style={{
                width: 200,
                height: 355,
                borderRadius: 10,
                overflow: "hidden",
                backgroundColor: "#000",
                position: "relative",
                cursor: "pointer",
              }}
              onClick={() => {
                setStartIndex(index);
                setIsFullscreen(true);
              }}
            >
              <video
                src={video.src}
                autoPlay
                muted
                loop
                playsInline
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: 10,
                }}
              />
              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  background: "rgba(0, 0, 0, 0.6)",
                  color: "#fff",
                  padding: "10px",
                  fontSize: 12,
                  lineHeight: 1.4,
                }}
              >
                <div style={{ marginBottom: 6 }}>{video.title}</div>
                <div style={{ fontWeight: "bold" }}>{video.name}</div>
                <div>{video.location}</div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Fullscreen Swiper Modal */}
        {isFullscreen && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              background: "#000",
              zIndex: "9999",
            }}
          >
            <button
              onClick={() => setIsFullscreen(false)}
              style={{
                position: "absolute",
                top: 20,
                right: 20,
                zIndex: 10000,
                color: "#fff",
                fontSize: 24,
                background: "transparent",
                border: "none",
                cursor: "pointer",
              }}
            >
              ✕
            </button>
            <Swiper
              initialSlide={startIndex}
              spaceBetween={0}
              slidesPerView={1}
              id="handleVideo"
              // className="w-50"
              style={{ width: "100%", maxWidth: " 450px" }}
              // style={{ height: '100%', width: '100%', padding: "0" }}
            >
              {videoList?.map((video) => (
                <SwiperSlide key={video.id} style={{}}>
                  <video
                    src={video.src}
                    autoPlay
                    muted
                    loop
                    controls
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        )}
      </div>
    );
  };

  const handleCityClick2 = (selectedCity: string) => {
    const city = locationMap.find((c) => c.cityName === selectedCity);

    // console.log(city, "641646464646");

    if (city) {
      localStorage.setItem("selectedCity", city.cityName);
      localStorage.setItem("selectedCityId", city.id.toString());

      localStorage.removeItem("selectedLatLng");
      localStorage.removeItem("selectedLocality");
    }

    // ---- store is_from_home_screen ----
    // localStorage.setItem("is_from_home_screen", "true");

    navigate("/search-result");
  };

  // -------- render property by category & Type ------
  let propertyCategory = [
    { value: "ROOMS", label: "Rooms", image: ROOMS_image },
    { value: "1RK", label: "1 RK", image: RK1_image },
    { value: "2RK", label: "2 RK", image: RK2_image },
    { value: "1BHK", label: "1 BHK", image: BHK1_image },
    { value: "2BHK", label: "2 BHK", image: BHK2_image },
    { value: "3BHK", label: "3 BHK", image: BHK3_image },
  ];

  const renderPropertyCategories = (): JSX.Element | null => {
    const CategorySummary: any = propertyData?.category_summary;

    // console.log(
    //   ">>> category <<<",
    //   Object.entries(CategorySummary || {}).length
    // );
    // console.log(">>> category summary <<<", Object.keys(CategorySummary));
    // if (!Object.keys(CategorySummary || {})?.length) return <></>;
    return (
      <>
        {propertyLoading && (
          <div style={{ marginLeft: "1.5rem" }}>
            <CustomLoaderSmall size="30px" />
          </div>
        )}

        {/* {!propertyLoading && Object.keys(CategorySummary || {})?.length > 0 && (
          <></>
        )} */}
        {!propertyLoading && Object.keys(CategorySummary || {})?.length > 0 && (
          <div style={{ marginTop: "20px" }}>
            {/* <CustomLoader /> */}
            <components.BlockHeading
              title="Property category"
              // viewAllOnClick={() => { }}
              containerStyle={{ marginBottom: 12, padding: "0 20px" }}
            />
            <Swiper
              spaceBetween={16}
              // autoplay={"true"}
              slidesPerView={"auto"}
              pagination={{ clickable: true }}
            >
              {propertyCategory?.length === 0 ? (
                <NoDataFound message="No category found" />
              ) : (
                propertyCategory
                  // ?.slice(0, 6)
                  ?.map((category: any, index: number) => {
                    const resultCount = CategorySummary?.[category.value];
                    // console.log(category);
                    if (!resultCount) return null;
                    return (
                      <SwiperSlide
                        key={category?.value + index}
                        style={{
                          // width: 230,
                          width: 200,
                          height: 130,
                          cursor: "pointer",
                          userSelect: "none",
                          borderRadius: 2,
                          display: "flex",
                          flexDirection: "column",
                          position: "relative",
                          // border: "1px solid red",
                          background: "rgba(0, 0, 0, 0.5)",
                        }}
                        onClick={() => {
                          localStorage.setItem("category", category.value);

                          // ---- store is_from_home_screen ----
                          // localStorage.setItem("is_from_home_screen", "true");

                          navigate(
                            "/search-result",
                            //  { state: { filter } }
                          );
                        }}
                      >
                        <div className="propCategoryWrapper">
                          <div
                            className="nearestCardBackground"
                            style={{
                              backgroundImage: `url(${category?.image})`,
                            }}
                          />
                          <div
                            className="nearestCardContent"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "space-between",
                              gap: "0px",
                              height: "100%",
                              // background: "none",
                              background: "rgba(0, 0, 0, 0.15)",
                              // background: "rgba(0, 0, 0, 0.13)",
                            }}
                          >
                            {/* Property name */}
                            <p
                              className="nearestCardTyp"
                              style={{
                                fontSize: "16px",
                                fontWeight: "bold",
                                color: "white",
                              }}
                            >
                              {category.label}
                            </p>
                            <p style={{ fontSize: "12.5px" }}>
                              {resultCount ?? 0} listing
                            </p>
                          </div>
                        </div>
                      </SwiperSlide>
                    );
                  })
              )}
            </Swiper>
          </div>
        )}
      </>
    );
  };

  const genderOptions = [
    { value: "Male", label: "PG For Men", image: Men_image },
    { value: "Female", label: "PG For Women", image: Women_image },
    { value: "Others", label: "CoLiving PG", image: Couple_image },
  ];

  const renderPropertyType = (): JSX.Element | null => {
    return (
      <div style={{ marginTop: "30px", marginBottom: "30px" }}>
        <components.BlockHeading
          title="Property Type"
          // viewAllOnClick={() => { }}
          containerStyle={{ marginBottom: 12, padding: "0 20px" }}
        />
        <Swiper
          spaceBetween={10}
          slidesPerView={"auto"}
          // breakpoints={{
          //   0: { slidesPerView: 1 },
          //   380: { slidesPerView: 2 },
          //   // 480: { slidesPerView: 2 },
          //   480: { slidesPerView: 3 },
          // }}
          pagination={{ clickable: true }}
        >
          {genderOptions?.length === 0 ? (
            <NoDataFound message="No category found" />
          ) : (
            genderOptions?.map((type: any, index: number) => (
              <SwiperSlide
                key={type?.value + index}
                className="propType_card"
                onClick={() => {
                  localStorage.setItem("gender", type.value);
                  localStorage.setItem("genderAPI", type.value);

                  // ---- store is_from_home_screen ----
                  // localStorage.setItem("is_from_home_screen", "true");

                  navigate(
                    "/search-result",
                    //  { state: { filter } }
                  );
                }}
              >
                <div className="propType_image_container">
                  <img src={type.image} alt="" />
                </div>
                <div className="propType_content" style={{ flexGrow: 1 }}>
                  <p>{type?.label}</p>
                  <button type="button" className="propType_Btn">
                    Explore
                  </button>
                </div>
              </SwiperSlide>
            ))
          )}
        </Swiper>
        {/* <div className="propType_container">
          {propertyType?.map((type) => {
            return (
              <div className="propType_card">
                <div>
                  <img src={type.image} alt="" />
                </div>
                <div className="propType_content">
                  <p style={{ marginBottom: "11px" }}>PG for Men</p>
                  <button type="button" className="propType_Btn">
                    Explore
                  </button>
                </div>
              </div>
            );
          })}
        </div> */}
      </div>
    );
  };
  // -------- end property by category & Type ------

  const locationMap = [
    {
      id: 1,
      cityName: "Delhi",
      cityImage: require("../../assets/nestfin/delhi.png"),
    },
    {
      id: 2,
      cityName: "Noida",
      cityImage: require("../../assets/nestfin/noida.png"),
    },
    {
      id: 7,
      cityName: "Greater Noida",
      cityImage: require("../../assets/nestfin/greater_noida.png"),
    },
    {
      id: 3,
      cityName: "Gurugram",
      cityImage: require("../../assets/nestfin/grugram.png"),
    },
    //     {
    //   id: 4,
    //   cityName: "Greater Noida",
    //         cityImage:  require('../../assets/nestfin/grugram.png')
    // } ,
    //     {
    //   id: 5,
    //   cityName: "Faridabad",
    //         cityImage:  require('../../assets/nestfin/grugram.png')
    // } ,
    //     {
    //   id: 6,
    //   cityName: "Ghaziabad",
    //         cityImage:  require('../../assets/nestfin/grugram.png')
    // }
  ];

  const renderLocationGrid2 = () => {
    const selectedCity = localStorage.getItem("selectedCity");
    return (
      <>
        <div
          style={{
            marginLeft: "20px",
            marginBottom: "10px",
            backgroundColor: "#f0f4f8",
            // padding: "10px 15px",
            borderRadius: "8px",
            fontFamily: "Arial, sans-serif",
            color: "#333",
            fontWeight: "500",
            display: "inline-block",
          }}
        >
          Selected City:{" "}
          <span style={{ color: "#007BFF", fontWeight: "600" }}>
            {selectedCity}
          </span>
        </div>

        <div
          className="home-city-icon-container"
          style={{
            display: "flex",
            overflowX: "auto",
            padding: "10px",
            // gap: "18px",
            // border: "2px solid green",
            alignContent: "center",
            justifyContent: "center",
          }}
        >
          {locationMap.map((city, index) => (
            <div
              key={index}
              style={{
                flex: "0 0 auto",
                width: "70px",
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                wordWrap: "break-word",
                whiteSpace: "normal",
                // border: "1px solid red",
              }}
              onClick={() => handleCityClick2(city.cityName)}
            >
              <div
                className="text-align-center home-city-icon"
                style={{
                  width: "100%",
                  // border: "2px solid green",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <img
                  className=""
                  src={city.cityImage}
                  alt={city.cityName}
                  style={{
                    width: `${city.id == 7 ? "90%" : "100%"}`,
                    // height: `${city.id == 7 ? "92%" : "100%"}`,
                    // borderRadius: "8px",
                    // border: "2px solid red",
                    borderRadius: "4px",
                    display: "block",
                  }}
                />
              </div>
              <span
                style={{ fontSize: "12px", display: "block", marginTop: "4px" }}
              >
                {city.cityName}
              </span>
            </div>
          ))}
        </div>
      </>
    );
  };

  const FAQData = [
    {
      id: 1,
      title: "What is Nestfin?",
      content:
        "NestFin is an end-to-end Property Management and Rental Platform that helps you find and manage the best PGs, Coliving spaces, and fully furnished rooms across India. Whether you're looking for a PG in Delhi, PG in Noida, PG in Gurugram, or professionally managed coliving properties, NestFin simplifies the entire experience—from discovery to move-in to rent payments.",
    },
    {
      id: 2,
      title: "Is a security deposit required?",
      content:
        "Yes. Most NestFin-listed properties—whether PG for Girls, PG for Boys, or fully furnished co-living rooms—require a security deposit. The amount varies based on:",
      lists: [
        "Property location (PG in Noida, PG in Delhi)",
        "Amenities",
        "Type of accommodation (sharing, private, fully furnished, etc.)",
      ],
      secondContent:
        "Deposit details are always shown clearly on each property listing.",
    },
    {
      id: 3,
      title: "What is the cancellation policy on Nestfin?",
      content:
        "Cancellation policies are set by individual property owners and operators. You can view the exact policy on each listing before booking. Refund timelines, notice periods, and deductions may vary between Coliving spaces, fully furnished PGs, and independent rooms.",
    },
    {
      id: 4,
      title: "Where are NestFin services available?",
      content:
        "NestFin currently operates across major rental and co-living cities, including:",
      lists: [
        "PG in Delhi",
        "PG in Noida",
        "PG in Gurugram",
        "Other metros and Tier-1 cities (expanding every month)",
      ],
      secondContent:
        "Users can browse verified listings of co-living rooms, PG for Girls and Boys, and fully furnished stay options.",
    },
    {
      id: 5,
      title: "What types of properties are available on NestFin?",
      content: "NestFin features a wide range of rental choices:",
      lists: [
        "Fully furnished PGs",
        "PG for Girls / PG for Boys",
        "Shared rooms (2/3/4 sharing)",
        "Private rooms",
        "Premium co-living properties",
        "Studio rooms & managed apartments",
        "Budget-friendly PGs in Delhi, Noida, Gurugram",
      ],
      secondContent:
        "All listings include photos, amenities, rent details, and digital tools for a seamless stay experience.",
    },
    // {
    //   id: 6,
    //   title: "Are there any hidden charges?",
    //   content:
    //     "No, Nestfin is transparent. All fees and charges are shown clearly before you apply. There are no hidden costs.",
    // },
  ];

  const faqSection = () => {
    return (
      <div style={{ marginTop: "30px", marginBottom: "30px" }}>
        <components.BlockHeading
          title="Frequently Asked Questions (FAQ's)"
          // viewAllOnClick={() => { }}
          containerStyle={{ marginBottom: 12, padding: "0 20px" }}
        />
        <HelpAndSupport faqData={FAQData} />
      </div>
    );
  };

  // ----- remove from is_from_home_screen -----
  useEffect(() => {
    // localStorage.removeItem("is_from_home_screen");
    localStorage.removeItem("is_add_max_min");
  }, []);

  const renderContent = (): JSX.Element => {
    return (
      <main>
        {renderTopBlock()}
        {renderSearchBar()}
        {renderLocationGrid2()}
        {renderPropertyCategories()}
        {renderPropertyType()}
        {renderBanner()}
        {propertyLoading ? (
          <CustomLoader />
        ) : (
          <>
            {renderNearest()}
            {renderNearest4()}
            {/* {renderTopRatedCourses()} */}
            {/* {renderCarousel()} */}
            {renderNearest2()}

            {fetchPropertyNearMeLoading ? (
              <>
                <CustomLoader />
              </>
            ) : (
              !!fetchPropertyNearMe?.data?.length && renderNearest3()
              // <></>
            )}

            {/* {renderNearest3()} */}
            {/* {renderBanner2()} */}
            {renderReelReview()}
            {/* {renderReview()} */}
          </>
        )}

        {/* ✅ Always visible */}
        {renderCounter()}
        {renderBottomCard()}
        {faqSection()}
      </main>
    );
  };

  // const renderContent = (): JSX.Element => {
  //   return <main>{faqSection()}</main>;
  // };

  return (
    <>
      <Helmet>
        <link rel="canonical" href="https://tenants.nestfin.app/home" />
        <meta property="og:url" content="https://tenants.nestfin.app/home" />
      </Helmet>
      <div style={{ position: "relative" }}>
        {renderHeader()}
        {renderContent()}
        {renderBottomTabBar()}

        {/* ✅ Location Popup */}
        {showLocationPopup && (
          <div className="location-overlay">
            <div className="location-modal">
              <div className="location-content">
                <h3>Allow Your Location</h3>
                <p>
                  To help you find the best options near you, we need access to
                  your location. Your privacy is important to us.
                </p>

                <div style={{ marginTop: "20px" }}>
                  <button
                    className="allow-btn"
                    onClick={() => handleAllowLocation("Allow")}
                  >
                    Allow
                  </button>

                  <button
                    className="deny-btn"
                    onClick={() => handleAllowLocation("Don't Allow")}
                    style={{ marginLeft: "10px" }}
                  >
                    Don't Allow
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ===== whatsapp icon ===== */}
        <div
          className="fixed-icon-container"
          style={{ zIndex: isDrawerOpen ? 0 : 9997 }}
        >
          <button
            type="button"
            onClick={() => {
              const message = `Hi, I need your assistant.`;
              const encodedMessage = encodeURIComponent(message);
              const whatsappUrl = `https://wa.me/${Nestfin_Number}?text=${encodedMessage}`;
              window.open(whatsappUrl, "_blank");
            }}
            className="fixed-whatsp-icon"
            // d-inline-flex h-13 w-13 rounded-full p-0.5 bg-white shadow-sm shadow-gray-300 animate-bounc cursor-pointer
          >
            <img
              src={WhatsappIcon}
              alt="whatspp-icon"
              className="h-100 w-100 object-fit-cover rounded-5 "
            />
          </button>
        </div>
      </div>
    </>
  );
};
